export interface AirportSizeFilterType {
  airportSize: server.dto.AirportSizeFilterOptions
}

export const initialAirportSizeFilter: AirportSizeFilterType = {
  airportSize: "onlyMajor"
}